import { render, staticRenderFns } from "./DelMenuGroup.vue?vue&type=template&id=4210d7cc&scoped=true"
import script from "./DelMenuGroup.vue?vue&type=script&lang=js"
export * from "./DelMenuGroup.vue?vue&type=script&lang=js"
import style0 from "./DelMenuGroup.vue?vue&type=style&index=0&id=4210d7cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4210d7cc",
  null
  
)

export default component.exports